export const configure = (app) => {
  const globalProperties = {
    $image: (fileName) =>
      `/media/images/${appData.master.identifier}/${fileName}`,
    $socialImage: (socialName) => `/static/socials/${socialName}.png`,
    $randomImage: (x, y) => `https://picsum.photos/${x}${y ? "/" + y : ""}`,
  };

  Object.entries(globalProperties).forEach(([key, value]) => {
    app.config.globalProperties[`${key}`] = value;
  });

  return app;
};
